import {
  materialColumnTypeDict,
  materialTemplateDefineTypeDict,
  materialTemplateKeySupplierRequireDict,
  materialTemplateKeySupplierVisibleDict
} from '@/dictionary/material/template'

/**
 * @description 新版品目模板型的通用数据
 */

export default {
  data() {
    return {
      // 品目模板配置列表
      columnConfig: [],
      // 品目信息列要展示的模板
      materielInfoConfig: [],
      // 采购人指定列要展示的模板
      purchaseSpecifyConfig: [],
      // 供应商响应列要展示的模板
      supplierResponseConfig: []
    }
  },

  computed: {
    // 品目名称字段
    nameConfig() {
      return (
        this.columnConfig.find(
          item => item.columnType === materialColumnTypeDict.NAME.value
        ) || {}
      )
    },

    // 品目编码的模板配置
    codeConfig() {
      return (
        this.columnConfig.find(
          item => item.columnType === materialColumnTypeDict.CODE.value
        ) || {}
      )
    },

    // 采购量的模板配置
    numConfig() {
      return (
        this.columnConfig.find(
          item => item.columnType === materialColumnTypeDict.NUM.value
        ) || {}
      )
    },

    // 采购单位的模板配置
    unitConfig() {
      return (
        this.columnConfig.find(
          item => item.columnType === materialColumnTypeDict.UNIT.value
        ) || {}
      )
    },

    // 预算单价的模板配置
    unitPriceConfig() {
      return (
        this.columnConfig.find(
          item => item.columnType === materialColumnTypeDict.UNIT_PRICE.value
        ) || {}
      )
    },

    // 参数型号的模板配置
    modelConfig() {
      return (
        this.columnConfig.find(
          item => item.columnType === materialColumnTypeDict.MODEL.value
        ) || {}
      )
    },

    // 控制价的模板配置
    controlPriceConfig() {
      const config =
        this.columnConfig.find(
          item => item.columnType === materialColumnTypeDict.CONTROL_PRICE.value
        ) || {}
      return config
    }
  },

  methods: {
    /**
     * 转换后台返回的基础字段模板，添加用于前端交互的字段
     */
    setColumnConfig(defineList) {
      this.columnConfig = (defineList || []).map(item => {
        return {
          columnName: item.columnName,
          // 字段类型为品目名称的或自定义的，均可以修改名称
          canEditColumnName:
            item.columnType === materialColumnTypeDict.NAME.value ||
            item.columnType === materialColumnTypeDict.CUSTOM.value,
          defineType: item.defineType,
          defineCode: item.defineCode,
          supplierRequire: item.supplierRequire,
          supplierVisible: item.supplierVisible,
          enable: item.isEnable === 1,
          isEnable: item.isEnable,
          columnType: item.columnType,
          // 字段类型为参数型号或自定义的，可以设置是否启用
          canEditEnable:
            item.columnType === materialColumnTypeDict.CUSTOM.value ||
            item.columnType === materialColumnTypeDict.MODEL.value ||
            item.columnType === materialColumnTypeDict.CONTROL_PRICE.value
        }
      })
      this.setTableConfig()
    },

    /**
     * 设定用于表格展示的相应信息模板
     */
    setTableConfig() {
      this.materielInfoConfig = []
      this.purchaseSpecifyConfig = []
      this.supplierResponseConfig = []

      this.columnConfig.forEach(item => {
        // 获取品目名称和品目编码的字段配置
        if (
          item.columnType === materialColumnTypeDict.NAME.value ||
          item.columnType === materialColumnTypeDict.CODE.value
        ) {
          this.materielInfoConfig.push(item)
        }
        // 获取供应商响应且已启用的字段配置
        if (
          item.defineType === materialTemplateDefineTypeDict.RESPONSE.value &&
          item.isEnable
        ) {
          this.supplierResponseConfig.push(item)
        }
        // 获取采购人指定且已启用的字段配置
        if (
          item.defineType === materialTemplateDefineTypeDict.SPECIFY.value &&
          item.isEnable
        ) {
          this.purchaseSpecifyConfig.push(item)
        }
      })

      // 由于模板中不存在分类的定义，需要手动添加分类
      this.materielInfoConfig.push({
        defineCode: 'categoryId',
        columnName: '分类'
      })
    },

    /**
     * 设定用于供应商端查看的相应信息模板
     */
    setSupplierConfig() {
      this.materielInfoConfig = []
      this.purchaseSpecifyConfig = []
      this.supplierResponseConfig = []

      this.columnConfig.forEach(item => {
        // 获取品目名称和品目编码的字段配置
        if (
          item.columnType === materialColumnTypeDict.NAME.value ||
          item.columnType === materialColumnTypeDict.CODE.value
        ) {
          this.materielInfoConfig.push(item)
        }
        // 获取供应商响应且已启用的字段配置
        if (
          item.defineType === materialTemplateDefineTypeDict.RESPONSE.value &&
          item.isEnable
        ) {
          this.supplierResponseConfig.push(item)
        }
        // 获取采购人指定且已启用的字段配置
        if (
          item.defineType === materialTemplateDefineTypeDict.SPECIFY.value &&
          item.isEnable
        ) {
          // 在供应商视角需要隐藏对供应商不可见的采购人指定
          if (
            item.supplierVisible ===
            materialTemplateKeySupplierVisibleDict.YES.value
          ) {
            this.purchaseSpecifyConfig.push(item)
          }
        }
      })

      // 由于模板中不存在分类的定义，需要手动添加分类
      this.materielInfoConfig.push({
        defineCode: 'categoryId',
        columnName: '分类'
      })
    },

    /**
     * 设定用于供应商端报价表的相应信息模板
     * @param {Boolean} requireTax 是否含税
     * @param {Boolean} isSupplier 供应商视角
     * @param {Boolean} hideTaxRate 是否隐藏税率信息
     */
    setSupplierOfferConfig(
      requireTax = false,
      isSupplier = false,
      hideTaxRate = false,
      isDollar = false
    ) {
      this.materielInfoConfig = []
      this.purchaseSpecifyConfig = []
      this.supplierResponseConfig = []
      // 供应商端的供应商响应列需要添加报价相关的字段
      this.supplierResponseConfig = [
        {
          columnName: requireTax
            ? `含税价（${isDollar ? '美元' : '元'}）`
            : `未含税价（${isDollar ? '美元' : '元'}）`,
          defineType: materialTemplateDefineTypeDict.RESPONSE.value,
          defineCode: 'offerPrice',
          supplierRequire: materialTemplateKeySupplierRequireDict.YES.value,
          supplierVisible: null,
          columnType: materialColumnTypeDict.CUSTOM.value
        },
        requireTax && !hideTaxRate
          ? {
            columnName: '税率（%）',
            defineType: materialTemplateDefineTypeDict.RESPONSE.value,
            defineCode: 'offerTaxRate',
            supplierRequire: materialTemplateKeySupplierRequireDict.YES.value,
            supplierVisible: null,
            columnType: materialColumnTypeDict.CUSTOM.value
          }
          : undefined,
        requireTax && !hideTaxRate
          ? {
            columnName: `未含税价（${isDollar ? '美元' : '元'}）`,
            defineType: materialTemplateDefineTypeDict.RESPONSE.value,
            defineCode: 'noRateOfferPrice',
            supplierRequire: materialTemplateKeySupplierRequireDict.YES.value,
            supplierVisible: null,
            columnType: materialColumnTypeDict.CUSTOM.value
          }
          : undefined,
        {
          columnName: `报价总金额（${isDollar ? '美元' : '元'}）`,
          defineType: materialTemplateDefineTypeDict.RESPONSE.value,
          defineCode: 'offerTotalPrice',
          supplierRequire: materialTemplateKeySupplierRequireDict.YES.value,
          supplierVisible: null,
          columnType: materialColumnTypeDict.CUSTOM.value
        }
      ].filter(value => value)

      this.columnConfig.forEach(item => {
        // 获取品目名称和品目编码的字段配置
        if (
          item.columnType === materialColumnTypeDict.NAME.value ||
          item.columnType === materialColumnTypeDict.CODE.value
        ) {
          this.materielInfoConfig.push(item)
        }
        // 获取供应商响应且已启用的字段配置
        if (
          item.defineType === materialTemplateDefineTypeDict.RESPONSE.value &&
          item.isEnable
        ) {
          this.supplierResponseConfig.push(item)
        }
        // 获取采购人指定且已启用的字段配置
        if (
          item.defineType === materialTemplateDefineTypeDict.SPECIFY.value &&
          item.isEnable
        ) {
          // 在供应商视角需要隐藏对供应商不可见的采购人指定
          if (isSupplier) {
            if (
              item.supplierVisible ===
              materialTemplateKeySupplierVisibleDict.YES.value
            ) {
              this.purchaseSpecifyConfig.push(item)
            }
          } else {
            this.purchaseSpecifyConfig.push(item)
          }
        }
      })

      // 由于模板中不存在分类的定义，需要手动添加分类
      this.materielInfoConfig.push({
        defineCode: 'categoryId',
        columnName: '分类'
      })

      // 最后供应商响应中还需加入备注
      this.supplierResponseConfig.push({
        columnName: '备注',
        defineType: materialTemplateDefineTypeDict.RESPONSE.value,
        defineCode: 'offerRemark',
        supplierRequire: materialTemplateKeySupplierRequireDict.NO.value,
        supplierVisible: null,
        columnType: materialColumnTypeDict.CUSTOM.value
      })
    }
  }
}
